import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer,
  ViewContainerRef,
} from '@angular/core';

import { ActivatedRoute, Params, Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';

import { BudgetService } from '../service/budget.service';
import { CompanyService } from '../service/company.service';
import { HomeService } from '../service/home.service';
import { ProjectService } from '../service/project.service';

import { OtherService } from '../service/other.service';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.css'],
})
export default class BudgetComponent implements OnInit {
  constructor(
    private homeService: HomeService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private route: ActivatedRoute,
    private router: Router,
    vRef: ViewContainerRef,
    private toastr: ToastsManager,
    private otherService: OtherService,
    public renderer: Renderer,
    public elementRef: ElementRef
  ) {
    this.toastr.setRootViewContainerRef(vRef);
    this.showInstructions = false;
    this.projectId = localStorage.getItem('projectId');
    this.companyId = localStorage.getItem('companyId');
    this.getProjectData();
    // this.getProjectCompanyDetails();
    this.clearData();
    // this.getOtherFields();
  }

  @Input() print: boolean;

  @Output() budgetEmit: EventEmitter<any> = new EventEmitter();

  @Output() otherEmitBudget: EventEmitter<any> = new EventEmitter();

  @Output() projectEmitBudget: EventEmitter<any> = new EventEmitter();

  // DECLARATION OF ALL VARIABLES USED IN THIS FILE
  projectId = '';

  companyId = '';

  companyLogoUrl = '';

  projectName = '';

  businessType = '';

  constructionType = '';

  businessPurchasePrice = 0;

  businessPurchasePriceInt = 0;

  realEstatePurchasePrice = 0;

  realEstatePurchasePriceInt = 0;

  costPerSquareFeet = 0;

  costPerSquareFeetInt = 0;

  totalSquareFeet = 0;

  totalSquareFeetInt = 0;

  landAcquisitionCost = 0;

  landAcquisitionCostInt = 0;

  operatingCapital = 0;

  operatingCapitalInt = 0;

  maintenanceReserve = 0;

  maintenanceReserveInt = 0;

  maintenanceReserveContibution: string;

  maintenanceReserveContibutionInt: string;

  interiorGarageConversion = 0;

  interiorGarageConversionInt = 0;

  interiorKitchen = 0;

  interiorKitchenInt = 0;

  interiorBathrooms = 0;

  interiorBathroomsInt = 0;

  interiorPainting = 0;

  interiorPaintingInt = 0;

  interiorFlooring = 0;

  interiorFlooringInt = 0;

  interiorPlumbing = 0;

  interiorPlumbingInt = 0;

  interiorElectic = 0;

  interiorElecticInt = 0;

  interiorHVAC = 0;

  interiorHVACInt = 0;

  interiorFurnish = 0;

  interiorFurnishInt = 0;

  exteriorRoofing = 0;

  exteriorRoofingInt = 0;

  exteriorPaint = 0;

  exteriorPaintInt = 0;

  exteriorFoundation = 0;

  exteriorFoundationInt = 0;

  exteriorFraming = 0;

  exteriorFramingInt = 0;

  exteriorSeptic = 0;

  exteriorSepticInt = 0;

  exteriorDriveways = 0;

  exteriorDrivewaysInt = 0;

  exteriorLandscaping = 0;

  exteriorLandscapingInt = 0;

  specialSprinklerSystem = 0;

  specialSprinklerSystemInt = 0;

  specialVideoMonitoring = 0;

  specialVideoMonitoringInt = 0;

  specialSecurityLighting = 0;

  specialSecurityLightingInt = 0;

  specialPowerGenerator = 0;

  specialPowerGeneratorInt = 0;

  professionalClosingCosts = 0;

  professionalClosingCostsInt = 0;

  professionalLegal = 0;

  professionalLegalInt = 0;

  professionalEngineer = 0;

  professionalEngineerInt = 0;

  professionalGeneralConstruction = 0;

  professionalGeneralConstructionInt = 0;

  professionalGeneralConstructionCalculated = 0;

  professionalGeneralConstructionCalculatedInt = 0;

  projectOverrun = 0;

  projectOverrunInt = 0;

  projectOverrunCalculated = 0;

  projectOverrunCalculatedInt = 0;

  professionalUtilityDeposits = 0;

  professionalUtilityDepositsInt = 0;

  professionalFinancingPoints = 0;

  professionalFinancingPointsInt = 0;

  realEstateSubTotal = 0;

  capitalAccountSubTotal = 0;

  interiorSubTotal = 0;

  exteriorSubTotal = 0;

  specialItemsSubTotal = 0;

  professionalSubTotal = 0;

  grandTotal = 0;

  otherArray: any = [];

  tempInteriorArray: any = [];

  tempExteriorArray: any = [];

  tempSpecialArray: any = [];

  tempMiscellaneousArray: any = [];

  otherFieldsInterior: any = [];

  otherFieldsExterior: any = [];

  otherFieldsSpecial: any = [];

  otherFieldsMiscellaneous: any = [];

  showBPP: boolean;

  showLAC: boolean;

  showREPP: boolean;

  pretext: string;

  showInstructions: boolean;

  ngOnInit() {
    this.getCompanyData();
    this.getBudgetData();
  }

  // GET COMPANY DATA TO GET COMPANY LOGO
  getCompanyData() {
    this.companyService.getCompany(this.companyId).subscribe((res) => {
      this.companyLogoUrl = res.data[0].logoUrl;
    });
  }

  // GETTING PROJECT PAGE DATA
  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.operatingCapital = projectData.data[0].operating_capital;
      this.operatingCapitalInt = projectData.data[0].operating_capital;

      this.maintenanceReserve = projectData.data[0].maintenance_reserve;
      this.maintenanceReserveInt = projectData.data[0].maintenance_reserve;

      this.maintenanceReserveContibution = projectData.data[0].maintenance_reserve_contribution;
      this.maintenanceReserveContibutionInt = projectData.data[0].maintenance_reserve_contribution;
      this.projectEmitBudget.emit({ projectEmitBudget: true });
    });
  }

  // GETTING BUDGET PAGE'S SAVED DATA FOR THE FIRST TIME WHEN MOVE TO BUDGET PAGE
  getBudgetData() {
    this.budgetService.getBudget(this.projectId).subscribe(async (budgetData) => {
      this.businessType = budgetData.data[0].business_type;
      this.constructionType = budgetData.data[0].construction_type;
      this.businessPurchasePrice = budgetData.data[0].business_purchase_price;
      this.businessPurchasePriceInt = budgetData.data[0].business_purchase_price;

      this.realEstatePurchasePrice = budgetData.data[0].real_estate_purchase_price;
      this.realEstatePurchasePriceInt = budgetData.data[0].real_estate_purchase_price;

      this.costPerSquareFeet = budgetData.data[0].cost_per_square_feet;
      this.costPerSquareFeetInt = budgetData.data[0].cost_per_square_feet;

      this.totalSquareFeet = budgetData.data[0].total_square_feet;
      this.totalSquareFeetInt = budgetData.data[0].total_square_feet;

      this.landAcquisitionCost = budgetData.data[0].land_acquisition_cost;
      this.landAcquisitionCostInt = budgetData.data[0].land_acquisition_cost;

      this.interiorGarageConversion = budgetData.data[0].interior_garage_conversion;
      this.interiorGarageConversionInt = budgetData.data[0].interior_garage_conversion;

      this.interiorKitchen = budgetData.data[0].interior_kitchen;
      this.interiorKitchenInt = budgetData.data[0].interior_kitchen;

      this.interiorBathrooms = budgetData.data[0].interior_bathrooms;
      this.interiorBathroomsInt = budgetData.data[0].interior_bathrooms;

      this.interiorPainting = budgetData.data[0].interior_painting;
      this.interiorPaintingInt = budgetData.data[0].interior_painting;

      this.interiorFlooring = budgetData.data[0].interior_flooring;
      this.interiorFlooringInt = budgetData.data[0].interior_flooring;

      this.interiorPlumbing = budgetData.data[0].interior_plumbing;
      this.interiorPlumbingInt = budgetData.data[0].interior_plumbing;

      this.interiorElectic = budgetData.data[0].interior_electic;
      this.interiorElecticInt = budgetData.data[0].interior_electic;

      this.interiorHVAC = budgetData.data[0].interior_HVAC;
      this.interiorHVACInt = budgetData.data[0].interior_HVAC;

      this.interiorFurnish = budgetData.data[0].interior_furnish;
      this.interiorFurnishInt = budgetData.data[0].interior_furnish;

      this.exteriorRoofing = budgetData.data[0].exterior_roofing;
      this.exteriorRoofingInt = budgetData.data[0].exterior_roofing;

      this.exteriorPaint = budgetData.data[0].exterior_paint;
      this.exteriorPaintInt = budgetData.data[0].exterior_paint;

      this.exteriorFoundation = budgetData.data[0].exterior_foundation;
      this.exteriorFoundationInt = budgetData.data[0].exterior_foundation;

      this.exteriorFraming = budgetData.data[0].exterior_framing;
      this.exteriorFramingInt = budgetData.data[0].exterior_framing;

      this.exteriorSeptic = budgetData.data[0].exterior_septic;
      this.exteriorSepticInt = budgetData.data[0].exterior_septic;

      this.exteriorDriveways = budgetData.data[0].exterior_driveways;
      this.exteriorDrivewaysInt = budgetData.data[0].exterior_driveways;

      this.exteriorLandscaping = budgetData.data[0].exterior_landscaping;
      this.exteriorLandscapingInt = budgetData.data[0].exterior_landscaping;

      this.specialSprinklerSystem = budgetData.data[0].special_sprinkler_system;
      this.specialSprinklerSystemInt = budgetData.data[0].special_sprinkler_system;

      this.specialVideoMonitoring = budgetData.data[0].special_video_monitoring;
      this.specialVideoMonitoringInt = budgetData.data[0].special_video_monitoring;

      this.specialSecurityLighting = budgetData.data[0].special_security_lighting;
      this.specialSecurityLightingInt = budgetData.data[0].special_security_lighting;

      this.specialPowerGenerator = budgetData.data[0].special_power_generator;
      this.specialPowerGeneratorInt = budgetData.data[0].special_power_generator;

      this.professionalClosingCosts = budgetData.data[0].professional_closing_costs;
      this.professionalClosingCostsInt = budgetData.data[0].professional_closing_costs;

      this.professionalLegal = budgetData.data[0].professional_legal;
      this.professionalLegalInt = budgetData.data[0].professional_legal;

      this.professionalEngineer = budgetData.data[0].professional_engineer;
      this.professionalEngineerInt = budgetData.data[0].professional_engineer;

      this.professionalGeneralConstruction = budgetData.data[0].professional_general_construction;
      this.professionalGeneralConstructionInt =
        budgetData.data[0].professional_general_construction;

      this.professionalGeneralConstructionCalculated =
        budgetData.data[0].professional_general_construction_calculated;

      this.projectOverrun = isFinite(budgetData.data[0].project_overrun)
        ? budgetData.data[0].project_overrun
        : 0;
      this.projectOverrunInt = budgetData.data[0].project_overrun;

      this.projectOverrunCalculated = budgetData.data[0].project_overrun_calculated;

      this.professionalUtilityDeposits = budgetData.data[0].professional_utility_deposits;
      this.professionalUtilityDepositsInt = budgetData.data[0].professional_utility_deposits;

      this.professionalFinancingPoints = budgetData.data[0].professional_financing_points;
      this.professionalFinancingPointsInt = budgetData.data[0].professional_financing_points;

      // TO SHOW AND HIDE FIELDS ACCORDING TO FIELD SLECETED IN DROP DOWNS
      if (this.businessType === 'Existing') {
        this.showBPP = true;
      } else if (this.businessType === 'Start-Up') {
        this.showBPP = false;
        this.businessPurchasePrice = 0;
      }
      if (this.constructionType === 'Existing' || this.constructionType === 'Renovation') {
        // TO SET PREFIX WORD WHEN RENOVATION IS SELECTED
        if (this.constructionType === 'Renovation') {
          this.pretext = 'Reno ';
        } else {
          this.pretext = '';
        }
        this.showLAC = false;
        this.showREPP = true;
        this.landAcquisitionCost = 0;
      } else if (this.constructionType === 'New Build') {
        this.showREPP = false;
        this.showLAC = true;
        this.realEstatePurchasePrice = 0;
        this.pretext = '';
      }

      // CALL ALL OTHER FUNCTIONS THAT ARE USED WHEN MOVE TO BUDGET PAGE TO GET VALUES AND CALCULATE VALUES
      await this.getOtherFields();
      await this.realEstateTotal();
      await this.capitalAccountTotal();
      await this.interiorTotal();
      await this.exteriorTotal();
      await this.specialItemsTotal();
      await this.professionalTotal();
      await this.total();
    });
  }

  // ########### Other fields tasks ###############//
  // GET OTHER FILEDS DATA
  getOtherFields(): Promise<Boolean> {
    const self = this;
    this.tempInteriorArray = [];
    this.tempExteriorArray = [];
    this.tempSpecialArray = [];
    this.tempMiscellaneousArray = [];
    return new Promise((resolve, reject) => {
      self.otherService.getOtherFields(this.projectId, 'budget').subscribe((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].child === 'interior') {
            this.otherFieldsInterior.push(res.data[i]);
            this.tempInteriorArray.push(res.data[i]);
          } else if (res.data[i].child === 'exterior') {
            this.otherFieldsExterior.push(res.data[i]);
            this.tempExteriorArray.push(res.data[i]);
          } else if (res.data[i].child === 'special_items') {
            this.otherFieldsSpecial.push(res.data[i]);
            this.tempSpecialArray.push(res.data[i]);
          } else if (res.data[i].child === 'miscellaneous') {
            this.otherFieldsMiscellaneous.push(res.data[i]);
            this.tempMiscellaneousArray.push(res.data[i]);
          }
        }
        this.otherEmitBudget.emit({ otherEmitBudget: true });
        resolve(true);
      });
    });
  }

  // TO ADD OTHER FIELDS WHEN USER CLICK ON ADD OTHER BUTTON
  addInputField(parent, child) {
    const data = { projectId: this.projectId };
    const self = this;
    let array = [];

    this.otherService.saveOtherField(parent, child, data).subscribe(
      () => {
        this.clearData();
        this.getOtherFields().then(() => {
          if (child === 'interior') {
            array = self.otherFieldsInterior;
          } else if (child === 'exterior') {
            array = self.otherFieldsExterior;
          } else if (child === 'special_items') {
            array = self.otherFieldsSpecial;
          } else if (child === 'miscellaneous') {
            array = self.otherFieldsMiscellaneous;
          }
          setTimeout(() => {
            document.getElementById(`label${child}${array.length - 1}`).focus();
          }, 100);
        });
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  // TO CLEAR OTHER FIELDS ARRAYS BECAUSE WHEN NEW ENTRY COME THEN ALL ARRAYS SHOULD BE CLEAR FIRST
  clearData() {
    this.otherFieldsInterior = [];
    this.otherFieldsExterior = [];
    this.otherFieldsSpecial = [];
    this.otherFieldsMiscellaneous = [];
  }

  // TO REMOVE/DELETE OTHER FIELDS WHEN USER CLICK ON TRASH BUTTON TO DELETE OTHER FIELD ENTRY
  removeOtherField(id, child) {
    const array = [];
    const self = this;
    const data = { id, parent: 'budget' };
    this.otherService.removeOtherField(data).subscribe((res) => {
      if (child === 'interior') {
        self.otherFieldsInterior.length--;
      } else if (child === 'exterior') {
        self.otherFieldsExterior.length--;
      } else if (child === 'special_items') {
        self.otherFieldsSpecial.length--;
      } else if (child === 'miscellaneous') {
        self.otherFieldsMiscellaneous.length--;
      }
      this.totals();
    });
  }

  // TO UPDATE VALUES OF OTHER FIELDS WHEN FOCUSOUT FROM OTHER FIELDS ENTRY IN ORDER TO SAVE FIELDS VALUES ON CHANGE
  updateFieldNameValue(id, event, field_name, nodeIndex, child) {
    const self = this;
    let { value } = event.target;
    let variableName = '';

    // TO SAVE LEFT SIDE OTHER ENTRY i.e NAME OF FIELD
    if (field_name === 'name') {
      if (child === 'interior') {
        if (value === self.otherFieldsInterior[nodeIndex].field_name) {
          return;
        }
      } else if (child === 'exterior') {
        if (value === self.otherFieldsExterior[nodeIndex].field_name) {
          return;
        }
      } else if (child === 'special_items') {
        if (value === self.otherFieldsSpecial[nodeIndex].field_name) {
          return;
        }
      } else if (child === 'miscellaneous') {
        if (value === self.otherFieldsMiscellaneous[nodeIndex].field_name) {
          return;
        }
      }

      variableName = 'field_name';
      this.otherService.updateFieldNameValue(id, value, variableName).subscribe((res) => {});
    } else { // if (field_name === 'value')
      variableName = 'field_value';
      if (value === '' || value === null) {
        value = 0;
        if (child === 'interior') {
          self.otherFieldsInterior[nodeIndex].field_value = value;
        } else if (child === 'exterior') {
          self.otherFieldsExterior[nodeIndex].field_value = value;
        } else if (child === 'special_items') {
          self.otherFieldsSpecial[nodeIndex].field_value = value;
        } else if (child === 'miscellaneous') {
          self.otherFieldsMiscellaneous[nodeIndex].field_value = value;
        }
      }
      value = this.replaceDollarsCommasPercentages(event.target.value);
      this.otherService.updateFieldNameValue(id, value, variableName).subscribe((res) => {
        this.totals();
      });
    }
  }
  // ***************END OF OTHER TASKS ***************/

  // ################ TOTALS TASKS ################//
  // TO DO TOTAL OF REAL ESTATE AQUISATION SECTION
  realEstateTotal() {
    this.realEstateSubTotal =
      +this.realEstatePurchasePrice +
      +(this.costPerSquareFeet * this.totalSquareFeet) +
      +this.landAcquisitionCost;
  }

  // TO DO TOTAL OF CAPITAL ACCOUNTS SECTION
  capitalAccountTotal() {
    const value = +this.operatingCapital + +this.maintenanceReserve;
    if (isNaN(value) || value === null) {
      this.capitalAccountSubTotal = 0;
    } else {
      this.capitalAccountSubTotal = value;
    }
  }

  // TO DO TOTAL OF INTERIOR SECTION
  interiorTotal() {
    let otherInteriorSum = 0;
    for (let i = 0; i < this.otherFieldsInterior.length; i++) {
      otherInteriorSum += this.otherFieldsInterior[i].field_value;
    }
    this.interiorSubTotal =
      +this.interiorGarageConversion +
      +this.interiorKitchen +
      +this.interiorBathrooms +
      +this.interiorPainting +
      +this.interiorFlooring +
      +this.interiorPlumbing +
      +this.interiorElectic +
      +this.interiorHVAC +
      +this.interiorFurnish +
      +otherInteriorSum;

    // Calculate project Overrun $value(projectOverrunCalculated) i.e the non-input field
    // this.projectOverrunCalculated = ((this.projectOverrun/100)*((this.costPerSquareFeet * this.totalSquareFeet) + +this.interiorSubTotal + +this.exteriorSubTotal + +this.specialItemsSubTotal + +this.professionalLegal + +this.professionalEngineer + +this.professionalGeneralConstructionCalculated));
  }

  // TO DO TOTAL OF EXTERIOR SECTION
  exteriorTotal() {
    let otherExteriorSum = 0;
    for (let i = 0; i < this.otherFieldsExterior.length; i++) {
      otherExteriorSum += this.otherFieldsExterior[i].field_value;
    }
    this.exteriorSubTotal =
      +this.exteriorRoofing +
      +this.exteriorPaint +
      +this.exteriorFoundation +
      +this.exteriorFraming +
      +this.exteriorSeptic +
      +this.exteriorDriveways +
      +this.exteriorLandscaping +
      +otherExteriorSum;

    // Calculate project Overrun $value(projectOverrunCalculated) i.e the non-input field
    // this.projectOverrunCalculated = ((this.projectOverrun/100)*((this.costPerSquareFeet * this.totalSquareFeet) + +this.interiorSubTotal + +this.exteriorSubTotal + +this.specialItemsSubTotal + +this.professionalLegal + +this.professionalEngineer + +this.professionalGeneralConstructionCalculated));
  }

  // TO DO TOTAL OF SPECIAL ITEMS SECTION
  specialItemsTotal() {
    let otherSpecialSum = 0;
    for (let i = 0; i < this.otherFieldsSpecial.length; i++) {
      otherSpecialSum += this.otherFieldsSpecial[i].field_value;
    }
    this.specialItemsSubTotal =
      +this.specialPowerGenerator +
      +this.specialSecurityLighting +
      +this.specialSprinklerSystem +
      +this.specialVideoMonitoring +
      +otherSpecialSum;

    // Calculate project Overrun $value(projectOverrunCalculated) i.e the non-input field
    this.projectOverrunCalculated =
      (this.projectOverrun / 100) *
      (this.costPerSquareFeet * this.totalSquareFeet +
        +this.interiorSubTotal +
        +this.exteriorSubTotal +
        +this.specialItemsSubTotal +
        +this.professionalLegal +
        +this.professionalEngineer +
        +this.professionalGeneralConstructionCalculated);
  }

  // TO DO TOTAL OF PROFESSIONAL SECTION
  professionalTotal() {
    let otherProfessionalSum = 0;
    for (let i = 0; i < this.otherFieldsMiscellaneous.length; i++) {
      otherProfessionalSum += this.otherFieldsMiscellaneous[i].field_value;
    }
    this.professionalSubTotal =
      +this.professionalClosingCosts +
      +this.professionalLegal +
      +this.professionalEngineer +
      +this.professionalUtilityDeposits +
      +otherProfessionalSum +
      this.professionalGeneralConstructionCalculated +
      +this.projectOverrunCalculated +
      +this.professionalFinancingPoints;
  }

  // TO DO PROJECT SUMMARY TOTAL SECTION
  total() {
    const value = this.professionalGeneralConstruction;
    this.professionalGeneralConstructionCalculated =
      (value / 100) *
      (this.specialItemsSubTotal +
        this.interiorSubTotal +
        this.exteriorSubTotal +
        (this.realEstateSubTotal - this.realEstatePurchasePrice) -
        this.landAcquisitionCost);

    // Calculate project Overrun $value(projectOverrunCalculated) i.e the non-input field
    // this.projectOverrunCalculated = ((this.costPerSquareFeet * this.totalSquareFeet) + +this.interiorSubTotal + +this.exteriorSubTotal + +this.specialItemsSubTotal + +this.professionalLegal + +this.professionalEngineer + +this.professionalGeneralConstructionCalculated);
    const grandTotalValue =
      +this.businessPurchasePrice +
      +this.realEstateSubTotal +
      +this.capitalAccountSubTotal +
      +this.interiorSubTotal +
      +this.exteriorSubTotal +
      +this.specialItemsSubTotal +
      +this.professionalSubTotal;

    if (grandTotalValue === null || isNaN(grandTotalValue)) {
      this.grandTotal = 0;
    } else {
      this.grandTotal = grandTotalValue;
    }

    // TO UPDATE TOTALS IN BUDGETS TABLE AS WELL
    const data = {
      fieldName: 'totalCapital',
      value: this.grandTotal,
      total_business_price: this.businessPurchasePrice,
      total_realEstateSubTotal: this.realEstateSubTotal,
      total_capitalAccountSubTotal: this.capitalAccountSubTotal,
      total_interiorSubTotal: this.interiorSubTotal,
      total_exteriorSubTotal: this.exteriorSubTotal,
      total_specialItemsSubTotal: this.specialItemsSubTotal,
      total_professionalSubTotal: this.professionalSubTotal,
      professionalGeneralConstructionCalculated: this.professionalGeneralConstructionCalculated,
      projectOverrunCalculated: this.projectOverrunCalculated,
    };
    this.budgetService.updateBudget(this.projectId, data).subscribe(
      (res) => {
        if (res.messageId === 200) {
          this.budgetEmit.emit({ budgetEmit: true });
        } else if (res.messageId === 400) {
          // TODO: See if this case can still happen from this API
          this.toastr.error(res.message, 'Error!');
        }
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  // COMBINE ALL TOTAL FUNCTIONS HERE
  totals() {
    this.realEstateTotal();
    this.capitalAccountTotal();
    this.interiorTotal();
    this.exteriorTotal();
    this.specialItemsTotal();
    this.professionalTotal();
    this.total();
  }
  // *************END OD TOTALS TASKS ****************/

  // TO UPDATE CAPITAL ACCOUNTS SECTION ONCHANGE OF FIELD VALUE BECAUSE THESE ARE PART OF PROJECT DATA PAGE AND WILL SAVE IN DIFFERENT TABLE
  onUpdateProject(fieldName, event) {
    let value = this.replaceDollarsCommasPercentages(event.target.value);
    if (value === '' || value === null) {
      value = 0;
    }

    if (fieldName === 'operatingCapital') {
      if (value === this.operatingCapitalInt) {
        return;
      }
      this.operatingCapitalInt = value;
      this.operatingCapital = value;
    } else if (fieldName === 'maintenanceReserve') {
      if (value === this.maintenanceReserveInt) {
        return;
      }
      this.maintenanceReserveInt = value;
      this.maintenanceReserve = value;
    } else if (fieldName === 'maintenanceReserveContribution') {
      if (value === this.maintenanceReserveContibutionInt) {
        return;
      }
      this.maintenanceReserveContibution = value;
      this.maintenanceReserveContibutionInt = value;
    }

    // CALL SERVICE HERE
    const data = { fieldName, value };
    this.projectService.onChangeProject(this.projectId, data).subscribe(
      (res) => {
        if (res.messageId === 200) {
          this.totals();
        } else if (res.messageId === 400) {
          // TODO: See if this API can still cause this
          this.toastr.error(res.message, 'Error!');
        }
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  // TO UPDATE REST OF SECTION'S FIELDS OF BUDGET PAGE DATA ONCHANGE OF FIELD VALUE
  onUpdate(fieldName, event) {
    let value = this.replaceDollarsCommasPercentages(event.target.value);

    if (value === '' || value === null) {
      value = 0;
    }
    // CONDITIONS TO CHECK WHEATHER VALUE IS CHANGED OF NOT SO THAT SERVICE HIT WILL BE SAVED, AS WE CAN'T USE CHANGE FUNCTION IN MASKING SO WE HAVE USE FOCUSOUT FUNCTION. FOR THAT THESE CHECKS ARE NECCESARY
    if (fieldName === 'businessPurchasePrice') {
      this.businessPurchasePrice = value;
      if (value === this.businessPurchasePriceInt) {
        return;
      }
      this.businessPurchasePriceInt = value;
    } else if (fieldName === 'realEstatePurchasePrice') {
      this.realEstatePurchasePrice = value;
      if (value === this.realEstatePurchasePriceInt) {
        return;
      }
      this.realEstatePurchasePriceInt = value;
    } else if (fieldName === 'costPerSquareFeet') {
      this.costPerSquareFeet = value;
      if (value === this.costPerSquareFeetInt) {
        return;
      }
      this.costPerSquareFeetInt = value;
    } else if (fieldName === 'totalSquareFeet') {
      this.totalSquareFeet = value;
      if (value === this.totalSquareFeetInt) {
        return;
      }
      this.totalSquareFeetInt = value;
    } else if (fieldName === 'landAcquisitionCost') {
      this.landAcquisitionCost = value;
      if (value === this.landAcquisitionCostInt) {
        return;
      }
      this.landAcquisitionCostInt = value;
    } else if (fieldName === 'interiorGarageConversion') {
      this.interiorGarageConversion = value;
      if (value === this.interiorGarageConversionInt) {
        return;
      }
      this.interiorGarageConversionInt = value;
    } else if (fieldName === 'interiorKitchen') {
      this.interiorKitchen = value;
      if (value === this.interiorKitchenInt) {
        return;
      }
      this.interiorKitchenInt = value;
    } else if (fieldName === 'interiorBathrooms') {
      this.interiorBathrooms = value;
      if (value === this.interiorBathroomsInt) {
        return;
      }
      this.interiorBathroomsInt = value;
    } else if (fieldName === 'interiorFlooring') {
      this.interiorFlooring = value;
      if (value === this.interiorFlooringInt) {
        return;
      }
      this.interiorFlooringInt = value;
    } else if (fieldName === 'interiorPainting') {
      this.interiorPainting = value;
      if (value === this.interiorPaintingInt) {
        return;
      }
      this.interiorPaintingInt = value;
    } else if (fieldName === 'interiorPlumbing') {
      this.interiorPlumbing = value;
      if (value === this.interiorPlumbingInt) {
        return;
      }
      this.interiorPlumbingInt = value;
    } else if (fieldName === 'interiorElectic') {
      this.interiorElectic = value;
      if (value === this.interiorElecticInt) {
        return;
      }
      this.interiorElecticInt = value;
    } else if (fieldName === 'interiorHVAC') {
      this.interiorHVAC = value;
      if (value === this.interiorHVACInt) {
        return;
      }
      this.interiorHVACInt = value;
    } else if (fieldName === 'interiorFurnish') {
      this.interiorFurnish = value;
      if (value === this.interiorFurnishInt) {
        return;
      }
      this.interiorFurnishInt = value;
    } else if (fieldName === 'exteriorRoofing') {
      this.exteriorRoofing = value;
      if (value === this.exteriorRoofingInt) {
        return;
      }
      this.exteriorRoofingInt = value;
    } else if (fieldName === 'exteriorPaint') {
      this.exteriorPaint = value;
      if (value === this.exteriorPaintInt) {
        return;
      }
      this.exteriorPaintInt = value;
    } else if (fieldName === 'exteriorFoundation') {
      this.exteriorFoundation = value;
      if (value === this.exteriorFoundationInt) {
        return;
      }
      this.exteriorFoundationInt = value;
    } else if (fieldName === 'exteriorFraming') {
      this.exteriorFraming = value;
      if (value === this.exteriorFramingInt) {
        return;
      }
      this.exteriorFramingInt = value;
    } else if (fieldName === 'exteriorSeptic') {
      this.exteriorSeptic = value;
      if (value === this.exteriorSepticInt) {
        return;
      }
      this.exteriorSepticInt = value;
    } else if (fieldName === 'exteriorDriveways') {
      this.exteriorDriveways = value;
      if (value === this.exteriorDrivewaysInt) {
        return;
      }
      this.exteriorDrivewaysInt = value;
    } else if (fieldName === 'exteriorLandscaping') {
      this.exteriorLandscaping = value;
      if (value === this.exteriorLandscapingInt) {
        return;
      }
      this.exteriorLandscapingInt = value;
    } else if (fieldName === 'specialSprinklerSystem') {
      this.specialSprinklerSystem = value;
      if (value === this.specialSprinklerSystemInt) {
        return;
      }
      this.specialSprinklerSystemInt = value;
    } else if (fieldName === 'specialVideoMonitoring') {
      this.specialVideoMonitoring = value;
      if (value === this.specialVideoMonitoringInt) {
        return;
      }
      this.specialVideoMonitoringInt = value;
    } else if (fieldName === 'specialSecurityLighting') {
      this.specialSecurityLighting = value;
      if (value === this.specialSecurityLightingInt) {
        return;
      }
      this.specialSecurityLightingInt = value;
    } else if (fieldName === 'specialPowerGenerator') {
      this.specialPowerGenerator = value;
      if (value === this.specialPowerGeneratorInt) {
        return;
      }
      this.specialPowerGeneratorInt = value;
    } else if (fieldName === 'professionalClosingCosts') {
      this.professionalClosingCosts = value;
      if (value === this.professionalClosingCostsInt) {
        return;
      }
      this.professionalClosingCostsInt = value;
    } else if (fieldName === 'professionalLegal') {
      this.professionalLegal = value;
      if (value === this.professionalLegalInt) {
        return;
      }
      this.professionalLegalInt = value;
    } else if (fieldName === 'professionalEngineer') {
      this.professionalEngineer = value;
      if (value === this.professionalEngineerInt) {
        return;
      }
      this.professionalEngineerInt = value;
    } else if (fieldName === 'professionalGeneralConstruction') {
      this.professionalGeneralConstruction = value;
      if (value === this.professionalGeneralConstructionInt) {
        return;
      }
      this.professionalGeneralConstructionInt = value;
    } else if (fieldName === 'projectOverrun') {
      this.projectOverrun = value;
      if (value === this.projectOverrunInt) {
        return;
      }
      this.projectOverrunInt = value;
    } else if (fieldName === 'professionalUtilityDeposits') {
      this.professionalUtilityDeposits = value;
      if (value === this.professionalUtilityDepositsInt) {
        return;
      }
      this.professionalUtilityDepositsInt = value;
    } else if (fieldName === 'professionalFinancingPoints') {
      this.professionalFinancingPoints = value;
      if (value === this.professionalFinancingPointsInt) {
        return;
      }
      this.professionalFinancingPointsInt = value;
    }

    let data = {};

    if (fieldName === 'businessType') {
      value = event.target.value;
      data = { fieldName, value };
      if (value === 'Existing') {
        this.showBPP = true;
        setTimeout(function () {
          document.getElementById('businessPurchasePrice').focus();
        }, 100);
      } else if (value === 'Start-Up') {
        this.showBPP = false;
        this.businessPurchasePrice = 0;
      }
    } else if (fieldName === 'constructionType') {
      value = event.target.value;
      data = { fieldName, value };
      if (value === 'Existing') {
        this.pretext = '';
        this.showLAC = false;
        this.showREPP = true;
        this.landAcquisitionCost = 0;
        setTimeout(function () {
          document.getElementById('realEstatePurchasePrice').focus();
        }, 100);
      } else if (value === 'Renovation') {
        this.pretext = 'Reno ';
        this.showLAC = false;
        this.showREPP = true;
        this.landAcquisitionCost = 0;
        setTimeout(function () {
          document.getElementById('realEstatePurchasePrice').focus();
        }, 100);
      } else if (value === 'New Build') {
        this.pretext = '';
        this.showREPP = false;
        this.showLAC = true;
        this.realEstatePurchasePrice = 0;

        setTimeout(function () {
          document.getElementById('costPerSquareFeet').focus();
        }, 100);
      }
    } else if (fieldName === 'professionalGeneralConstruction') {
      this.professionalGeneralConstructionCalculated =
        (value / 100) *
        (this.specialItemsSubTotal +
          this.interiorSubTotal +
          this.exteriorSubTotal +
          (this.realEstateSubTotal - this.realEstatePurchasePrice) -
          this.landAcquisitionCost);

      data = { fieldName, value, value1: this.professionalGeneralConstructionCalculated };
    } else if (fieldName === 'projectOverrun') {
      this.projectOverrunCalculated =
        (value / 100) *
        (this.costPerSquareFeet * this.totalSquareFeet +
          +this.interiorSubTotal +
          +this.exteriorSubTotal +
          +this.specialItemsSubTotal +
          +this.professionalLegal +
          +this.professionalEngineer +
          +this.professionalGeneralConstructionCalculated);

      data = { fieldName, value, value1: this.projectOverrunCalculated };
    } else {
      data = { fieldName, value };
    }

    this.budgetService.updateBudget(this.projectId, data).subscribe(
      (res) => {
        if (res.messageId === 200) {
          this.totals();
        } else if (res.messageId === 400) {
          // TODO: See if this API can still cause this
          this.toastr.error(res.message, 'Error!');
        }
      },
      (err) => this.toastr.error(err.message, 'Error!')
    );
  }

  // calculateGeneralContractor(){
  //   var value = this.professionalGeneralConstruction;
  //   this.professionalGeneralConstructionCalculated = ((value/100)*((this.specialItemsSubTotal +this.interiorSubTotal + this.exteriorSubTotal + this.realEstateSubTotal) - this.landAcquisitionCost));
  //   // var data1 = { 'fieldName': 'professionalGeneralConstructionCalculated', 'value': this.professionalGeneralConstructionCalculated };
  //   // this.budgetService.updateBudget(this.projectId, data1).subscribe();
  // }

  // TO REMOVE DOLLER AND COMMAS FROM VALUES
  replaceDollarsCommasPercentages(value) {
    return value.replace(/[, $ %]+/g, '').trim();
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/budget/budget.component.ts